import { render, staticRenderFns } from "./TinymceVue.vue?vue&type=template&id=7a7628c1&scoped=true&"
import script from "./TinymceVue.vue?vue&type=script&lang=js&"
export * from "./TinymceVue.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a7628c1",
  null
  
)

export default component.exports